// extracted by mini-css-extract-plugin
export default {"noResults":"PageNoResults_noResults__2MN1d","md":"PageNoResults_md__R-RoU","lg":"PageNoResults_lg__8e7h1","bordered":"PageNoResults_bordered__wN-6I"};